<template>
  <div
    :class="carouselClasses"
    ref="carousel"
  >
    <div
      class="carousel-item-list"
      ref="itemList"
      :style="itemListStyle"
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    >
      <slot />
    </div>
    <div
      class="carousel-navigation"
      v-if="showNavigation"
    >
      <div
        v-for="(item, idx) in items"
        :key="idx"
        @click="dotGoTo(idx)"
        class="carousel-navigation__dot"
        :class="{active: idx === currentItemIndex}"
      >
        <font-awesome-icon
          size="xs"
          :icon="['fas', 'circle']"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCarousel',
  data() {
    return {
      items: [],
      currentItemIndex: 0,
      x0: null,
      autoplayPaused: false,
    }
  },
  props: {
    aspect: {
      type: String,
      default: null,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    autoplaySeconds: {
      type: Number,
      default: 5,
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goTo(idx) {
      this.currentItemIndex = idx
    },
    dotGoTo(idx) {
      this.autoplayPaused = true

      if (this.autoplayPausedTimeout) {
        clearTimeout(this.autoplayPausedTimeout)
      }

      this.autoplayPausedTimeout = setTimeout(() => {
        this.autoplayPaused = false
      }, 10000)
      this.goTo(idx)
    },
    next() {
      let nextIndex = this.currentItemIndex + 1
      if (!this.items[nextIndex]) {
        nextIndex = 0
      }
      this.goTo(nextIndex)
    },
    lock(e) {
      this.x0 = this.unifyEvent(e).clientX
    },
    // itemLinkBoxProps(item) {
    //   const props = item
    //   props.aspect = this.aspect
    //   return props
    // },
    move(e) {
      const i = this.currentItemIndex
      const N = this.items.length

      if (this.x0 || this.x0 === 0) {
        const dx = this.unifyEvent(e).clientX - this.x0
        const s = Math.sign(dx)

        if ((i > 0 || s < 0) && (i < N - 1 || s > 0)) {
          this.currentItemIndex -= s
        }
        this.x0 = null
      }
    },
    unifyEvent(e) {
      return e.changedTouches ? e.changedTouches[0] : e
    },
    mouseover() {
      if (this.autoplayPausedTimeout) {
        clearTimeout(this.autoplayPausedTimeout)
      }
      this.autoplayPaused = true
    },
    mouseleave() {
      if (!this.autoplayPausedTimeout) {
        this.autoplayPaused = false
      }
    },
  },
  mounted() {
    this.items = this.$refs.itemList.childNodes
    // TODO: check if for is really needed
    for (let i = 0, len = this.items.length; i < len; i += 1) {
      this.items[i].style.width = `${100 / this.items.length}%`
    }

    this.$refs.itemList.addEventListener('mousedown', this.lock, false)
    this.$refs.itemList.addEventListener('touchstart', this.lock, false)

    this.$refs.itemList.addEventListener('mouseup', this.move, false)
    this.$refs.itemList.addEventListener('touchend', this.move, false)

    if (this.autoplay) {
      this.autoplayInterval = setInterval(() => {
        if (!this.autoplayPaused) {
          this.next()
        }
      }, this.autoplaySeconds * 1000)
    }
  },
  beforeDestroy() {
    this.$refs.itemList.removeEventListener('mousedown', this.lock, false)
    this.$refs.itemList.removeEventListener('touchstart', this.lock, false)

    this.$refs.itemList.removeEventListener('mouseup', this.move, false)
    this.$refs.itemList.removeEventListener('touchend', this.move, false)

    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval)
    }
    if (this.autoplayPausedTimeout) {
      clearTimeout(this.autoplayPausedTimeout)
    }
  },

  updated() {
    this.items = this.$refs.itemList.childNodes
    // TODO: check if for is really needed
    for (let i = 0, len = this.items.length; i < len; i += 1) {
      this.items[i].style.width = `${100 / this.items.length}%`
    }
  },
  computed: {
    carouselClasses() {
      const classes = [
        'carousel',
      ]
      if (this.aspect === '1/1') {
        classes.push('carousel--aspect-1-1')
      } else if (this.aspect === '16/9') {
        classes.push('carousel--aspect-16-9')
      } else {
        classes.push('carousel--aspect-4-1')
      }
      return classes
    },
    itemListStyle() {
      const translate = `${(this.currentItemIndex / this.items.length) * -100}%`
      return {
        width: `${100 * this.items.length}%`,
        transform: `translate(${translate})`,
      }
    },

  },
}
</script>

<style lang="scss">
.carousel {
  overflow: hidden;
  width: 100%;
  img {
    pointer-events: none;
  }
  a {
    user-select: none;
    -webkit-user-drag: none;
  }
}

.carousel-item-list {
  display: flex;
  align-items: center;
  overflow-y: hidden;
  width: 100%;
  height: 100%;

  transition: transform 1s ease-out;
  /* // transition: transform calc(var(--f)*.5s) cubic-bezier(1, 1.59, .61, .74); */

}

.carousel__item {
  width: 100%;
  height: 100%;
  position: relative;
}

.carousel-navigation {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.carousel-navigation__dot {
  color: #ababab;
  padding: 5px;
  cursor: pointer;
  font-size: 16px;
  &.active {
    color: #7b7b7b;
  }
}

</style>
